<template>
  <div
    class="p-side-navigation"
    :class="{
      'p-side-navigation--horizontal': mode === 'horizontal',
      'p-side-navigation--vertical': mode === 'vertical',
    }"
  >
    <div
      v-for="(item, index) in items"
      :key="index"
      class="p-side-navigation__item"
      :class="{
        'p-side-navigation__item--horizontal': mode === 'horizontal',
        'p-side-navigation__item--vertical': mode === 'vertical',
      }"
      @click="handleItemClick(item)"
    >
      <p-icon
        v-if="item.icon"
        :icon="item.icon"
        class="p-side-navigation__item-icon-left"
        size="sm"
        :color="item.iconColor || 'fg-primary'"
      />
      <NuxtImg
        v-else-if="item.image_url"
        :src="item.image_url"
        class="p-side-navigation__item-image"
      />
      <span class="p-side-navigation__item-title f-utility-14-medium t-fg-primary">{{
        item.title
      }}</span>
      <p-icon
        class="p-side-navigation__item-icon-right"
        icon="caret-right"
        size="sm"
        color="fg-primary"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
interface NavigationItem {
  icon?: string
  title: string
  link?: string
  iconColor?: string
  image_url?: string
}

defineProps({
  items: {
    type: Array as () => NavigationItem[],
    required: true,
  },
  mode: {
    type: String as () => 'horizontal' | 'vertical',
    default: 'vertical',
  },
})

const emit = defineEmits(['item-click'])

const handleItemClick = (item: NavigationItem) => {
  emit('item-click', item)
}
</script>
